<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <div class="md-layout-item md-medium-size-50 md-size-20 mx-auto">
        <img height="68" width="180" :src="capital77Img" alt="CAPITAL77 logo" />
      </div>
      <div class="text-center">
        <h1 style="font-size: 26px">
          Créditos 100% digitales. Fácil, rápido y seguro
        </h1>
      </div>
    </div>
    <div class="md-layout-item md-size-50 md-small-size-100">
      <div class="md-layout-item md-size-75 md-medium-size-100 mx-auto">
        <product-card header-animation="true">
          <img
            height="68"
            width="180"
            slot="imageHeader"
            :src="worldImg"
            alt="CAPITAL77 dashboard image"
          />
          <md-icon slot="fixed-button">build</md-icon>

          <md-button
            @click="focusInput()"
            class="md-simple md-info md-just-icon"
            slot="second-button"
          >
            <md-icon>attach_money</md-icon>
            <md-tooltip md-direction="bottom">Solicitar crédito</md-tooltip>
          </md-button>
          <h4 slot="title" class="title">
            <a href="#">¿Qué es CAPITAL77?</a>
          </h4>
          <div slot="description" class="card-description">
            CAPITAL77 es una empresa de microcréditos por internet que genera
            acceso financiero por medio del uso de tecnología otorgando créditos
            desde $ 120.000 hasta por {{ formatCurrency(options.max) }}.
          </div>
        </product-card>
      </div>
    </div>
    <div class="md-layout-item md-size-50 md-small-size-100">
      <div class="md-layout-item md-size-75 md-medium-size-100 mx-auto">
        <product-card header-animation="true">
          <img
            class="img"
            slot="imageHeader"
            :src="technologyImg"
            alt="CAPITAL77 technology image"
            rel="preload"
          />
          <md-icon slot="fixed-button">build</md-icon>
          <md-button
            @click="goToHowItWorks()"
            class="md-simple md-info md-just-icon"
            slot="second-button"
          >
            <md-icon>description</md-icon>
            <md-tooltip md-direction="bottom">Cómo funciona</md-tooltip>
          </md-button>
          <h4 slot="title" class="title">
            <a href="#">Ventajas de CAPITAL77</a>
          </h4>
          <div slot="description" class="card-description">
            CAPITAL77 está convencida que por medio de un excelente
            comportamiento con las obligaciones financieras se irán abriendo
            oportunidades que permitan a todos los consumidores tener siempre un
            respaldo crediticio.
          </div>
        </product-card>
      </div>
    </div>
    <div class="md-layout-item md-small-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <div class="card-icon">
            <md-icon>attach_money</md-icon>
          </div>
          <h4 class="title">¿Cuánto necesitas?</h4>
        </md-card-header>
        <md-card-content>
          <ValidationProvider
            name="documentValue"
            :rules="
              'required|max_value:' + maxQuantity + '|min_value:' + options.min
            "
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <label>Cantidad de Dinero</label>
              <md-input
                ref="lolazo"
                v-model="credit.moneyBase"
                type="number"
              ></md-input>
            </md-field>
          </ValidationProvider>
          <label>Cantidad de Dinero</label>
          <vue-slider v-bind="options" v-model="credit.moneyBase"></vue-slider>
          <div class="stats" v-if="credit.moneyBase > maxQuantity">
            <md-icon class="text-danger">warning</md-icon>
            <md-tooltip md-direction="top"
              >A medida que vayas adquiriendo más créditos con la plataforma, tu
              cupo aumentará</md-tooltip
            >
            <a>Cantidad no permitida</a>
          </div>
        </md-card-content>
      </md-card>
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <div class="card-icon">
            <md-icon>today</md-icon>
          </div>
          <h4 class="title">
            Fecha de pago - <small>¿Cuándo puedes pagar?</small>
          </h4>
        </md-card-header>
        <md-card-content>
          <md-datepicker
            :md-disabled-dates="disabledDates"
            v-model="selectedDate"
          />
        </md-card-content>
      </md-card>
    </div>

    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
    >
      <nav-tabs-card>
        <template slot="content">
          <span class="md-nav-tabs-title">Revisión</span>
          <md-tabs class="md-info" md-alignment="left">
            <md-tab
              id="tab-home"
              md-label="Cálculo de crédito"
              md-icon="assignment"
            >
              <md-table class="table-full-width">
                <md-table-row slot="md-table-row" :class="getClass({ id: 0 })">
                  <md-table-cell md-label="Item">Capital</md-table-cell>
                  <md-table-cell md-label="Valor">{{
                    formatCapital()
                  }}</md-table-cell>
                </md-table-row>
                <md-table-row slot="md-table-row" :class="getClass({ id: 1 })">
                  <md-table-cell md-label="Item">Administración</md-table-cell>
                  <md-table-cell md-label="Valor">{{
                    calculateAdmin()
                  }}</md-table-cell>
                </md-table-row>
                <md-table-row slot="md-table-row" :class="getClass({ id: 0 })">
                  <md-table-cell md-label="Item">Seguro</md-table-cell>
                  <md-table-cell md-label="Valor">{{
                    calculateSecure()
                  }}</md-table-cell>
                </md-table-row>
                <md-table-row slot="md-table-row" :class="getClass({ id: 1 })">
                  <md-table-cell md-label="Item">Intereses</md-table-cell>
                  <md-table-cell md-label="Valor">{{
                    calculateInterests()
                  }}</md-table-cell>
                </md-table-row>
                <md-table-row slot="md-table-row" :class="getClass({ id: 0 })">
                  <md-table-cell md-label="Item">Tecnología</md-table-cell>
                  <md-table-cell md-label="Valor">{{
                    calculateTechnology()
                  }}</md-table-cell>
                </md-table-row>
                <md-table-row slot="md-table-row" :class="getClass({ id: 1 })">
                  <md-table-cell md-label="Item">IVA</md-table-cell>
                  <md-table-cell md-label="Valor">{{
                    calculateIVA()
                  }}</md-table-cell>
                </md-table-row>
                <md-table-row
                  v-if="calculateBenefitsNumber() != 0"
                  style="color: green"
                  slot="md-table-row"
                  :class="getClass({ id: 0 })"
                >
                  <md-table-cell md-label="Item"
                    >Descuento por beneficios</md-table-cell
                  >
                  <md-table-cell md-label="Valor">
                    {{ calculateBenefits() }}</md-table-cell
                  >
                </md-table-row>
                <md-table-row
                  slot="md-table-row"
                  style="font-weight: bold"
                  :class="getClass({ id: 1 })"
                >
                  <md-table-cell md-label="Item">Total a Pagar</md-table-cell>
                  <md-table-cell md-label="Valor">{{
                    calculateTotal()
                  }}</md-table-cell>
                </md-table-row>
              </md-table>
              <br />
            </md-tab>

            <md-tab
              id="tab-admin"
              md-label="Descripción de Cobros"
              md-icon="money_off"
            >
              <md-table v-model="items">
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell>{{ item.name }}</md-table-cell>
                  <md-table-cell>
                    {{ item.description }}
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </md-tab>
          </md-tabs>
          <div class="text-right">
            <md-button
              :disabled="loading"
              class="md-primary md-round"
              @click="goTo()"
            >
              Solicitar Crédito
              <md-icon>keyboard_arrow_right</md-icon>
            </md-button>
          </div>
        </template>
      </nav-tabs-card>
    </div>
  </div>
</template>
<script>
import { NavTabsCard, ProductCard } from "@/components";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import Constants from "../../constants";
import Swal from "sweetalert2";
import gql from "graphql-tag";
import { Tabs } from "@/components";

export default {
  components: {
    NavTabsCard,
    VueSlider,
    ProductCard
  },
  data() {
    return {
      loading: false,
      benefits: null,
      maxQuantity: 0,
      oldMaxQuantity: 600000,
      iva: 0,
      securityByMillion: 0,
      technologyPerDay: 0,
      interestsPercentage: 0,
      capital77Img: "./img/capital77/Logo_Blanco.webp",
      worldImg: "./img/capital77/capital_dashboard.webp",
      technologyImg: "./img/capital77/technology.webp",
      selectedDate: new Date(new Date().getTime() + 5 * (1000 * 3600 * 24)),
      disabledDates: date => {
        return (
          Constants.daysOfDifference(new Date(), date) < 5 ||
          Constants.daysOfDifference(new Date(), date) > 30
        );
      },
      credit: {
        moneyBase: 0,
        dayLimit: null
      },
      items: [
        {
          name: "Administración",
          description:
            "Se cancela cada 30 días, después del desembolso del dinero hay 30 días para garantizar el cupo asignado. Se debe pagar por contar con un crédito activo."
        },
        {
          name: "Seguro",
          description:
            "Es el pago de una póliza de aseguramiento sobre el valor total del préstamo en caso de muerte o incapacidad del titular."
        },
        {
          name: "Interés",
          description: "Calculando...% e.a."
        },
        {
          name: "Tecnología",
          description:
            "Este servicio está relacionado con el manejo de la plataforma. Con este se hace un chequeo de tu comportamiento de pago, de promociones, firma en línea, agilidad en la solicitud, verificar el desembolso del dinero y múltiples beneficios. Si deseas hacer el proceso offline, también lo puedes solicitar (enviar pagare y carta de instrucciones autenticado en notaria, carta laboral con vigencia no mayor a 30 días, extracto de los últimos 3 meses. El estudio del crédito se demora entre 3 y 5 días hábiles. Anexar carta de permiso de manejo de datos)."
        },
        {
          name: "IVA",
          description:
            "Impuesto al valor añadido, Calculando..% sobre el total de cargos."
        }
      ],
      options: {
        min: 0,
        max: 600000,
        interval: 10000,
        adsorb: true,

        tooltipFormatter: v =>
          `$${("" + v).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
      }
    };
  },
  created() {
    this.$apollo
      .query({
        query: gql`
          query getGlobalConfigs {
            configs {
              id: configId
              name: configName
              value: configValue
            }
          }
        `
      })
      .then(data => {
        for (let index = 0; index < data.data.configs.length; index++) {
          const element = data.data.configs[index];
          switch (element.id) {
            case Constants.CONFIG_ID_IVA:
              this.iva = element.value;
              break;
            case Constants.CONFIG_ID_TECHNOLOGY_PER_DAY:
              this.technologyPerDay = element.value;
              break;
            case Constants.CONFIG_ID_INTERESTS_PERCENTAGE:
              this.interestsPercentage = element.value;
              break;
            case Constants.CONFIG_ID_SECURITY_BY_MILLION:
              this.securityByMillion = element.value;
              break;
            case Constants.CONFIG_ID_CREDIT_QUANTITY_MAX:
              if (this.isLoggedIn()) {
                localStorage.setItem(
                  Constants.CREDIT_MAX_VALUE,
                  parseInt(element.value)
                );
                this.options.max = parseInt(element.value);
              } else {
                localStorage.setItem(
                  Constants.CREDIT_MAX_VALUE,
                  this.oldMaxQuantity
                );
              }
              break;
            case Constants.CONFIG_ID_CREDIT_QUANTITY_MIN:
              this.options.min = parseInt(element.value);
              this.credit.moneyBase = parseInt(element.value);
              break;
            default:
              break;
          }
        }
        this.items[2].description =
          Math.ceil(this.interestsPercentage * 30 * 12 * 100) + "% e.a.";
        this.items[4].description =
          "Impuesto al valor añadido, " +
          this.iva * 100 +
          "% sobre el total de cargos.";
      })
      .catch(error => {
        Constants.catchError(
          error,
          this.$apollo.provider.defaultClient,
          this,
          true
        );
      });
    this.$apollo
      .query({
        query: gql`
          query calculateValidQuantityByDocumentValue($documentValue: String) {
            calculateValidQuantityByDocumentValue(documentValue: $documentValue)
          }
        `,
        variables: {
          documentValue: Constants.getUserDocumentValue()
        }
      })
      .then(data => {
        this.maxQuantity = data.data.calculateValidQuantityByDocumentValue;
      });
    if (Constants.getUserDocumentValue()) {
      this.$apollo
        .query({
          query: gql`
            query findBenefitsByDocumentValue($documentValue: String) {
              findBenefitsByDocumentValue(documentValue: $documentValue) {
                value: categoryBenefitValue
                benefit: capBenefit {
                  id: benefitId
                  name: benefitName
                  description: benefitDescription
                }
              }
            }
          `,
          variables: {
            documentValue: Constants.getUserDocumentValue()
          }
        })
        .then(data => {
          this.benefits = data.data.findBenefitsByDocumentValue;
        });
    }
  },
  methods: {
    formatCurrency(value) {
      return Constants.currencyValue(value);
    },
    isLoggedIn() {
      return Constants.getUserId() != null;
    },
    calculateBenefits() {
      return Constants.currencyValue(this.calculateBenefitsNumber());
    },
    calculateBenefitsNumber() {
      let benefits = 0;
      if (this.benefits != null) {
        for (let index = 0; index < this.benefits.length; index++) {
          const benefitObj = this.benefits[index];
          if (benefitObj.benefit.id == Constants.BENEFIT_ADMIN)
            benefits += (this.calculateAdminNumber() * benefitObj.value) / 100;
          else if (benefitObj.benefit.id == Constants.BENEFIT_TECH)
            benefits +=
              (this.calculateTechnologyNumber() * benefitObj.value) / 100;
        }
        benefits *= -1;
      }
      return benefits;
    },
    focusInput() {
      console.log("a");
      this.$refs.lolazo.$el.focus();
    },
    goTo(req, address) {
      if (Constants.getUserDocumentValue()) {
        this.loading = true;
        this.credit.dayLimit = this.calculateDays();
        this.$apollo
          .mutate({
            mutation: gql`
              mutation createCredit($credit: pCredit!, $capAccount: String!) {
                createCredit(credit: $credit, capAccount: $capAccount) {
                  creditId
                  dayLimit
                  moneyBase
                  capCurrentStatus {
                    stateName
                  }
                }
              }
            `,
            variables: {
              credit: this.credit,
              capAccount: Constants.getUserDocumentValue()
            },
            update: (cache, mutationResult) => {
              this.loading = false;
              let creditResult = mutationResult.data.createCredit;
              Swal.fire({
                title: "Crédito creado",
                text:
                  "Tu crédito se ha registrado con estado " +
                  creditResult.capCurrentStatus.stateName,
                confirmButtonClass: "md-button md-primary",
                buttonsStyling: false
              }).then(() => {
                this.$router.push("/credit-list/");
                this.$router.go();
              });
            }
          })
          .catch(error => {
            this.loading = false;
            Constants.catchError(
              error,
              this.$apollo.provider.defaultClient,
              this,
              false
            );
          });
      } else
        Swal.fire({
          title: "Siguiente paso",
          text: `¿Tienes una cuenta registrada?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-primary",
          cancelButtonClass: "md-button md-info",
          confirmButtonText: "Sí",
          cancelButtonText: "No",
          buttonsStyling: false
        }).then(result => {
          sessionStorage.setItem(Constants.CREDIT_VALUE, this.credit.moneyBase);
          sessionStorage.setItem(Constants.CREDIT_DAYS, this.calculateDays());
          if (result.value) {
            this.$router.push("/login/");
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            if (this.credit.moneyBase > 200000)
              Swal.fire({
                title: "Reduce la cantidad",
                text:
                  "Al ser tu primer crédito, puedes pedir como máximo $200.000",
                timer: 3000,
                showConfirmButton: false
              });
            else this.$router.push("/register-account/");
          }
        });
    },
    goToHowItWorks() {
      this.$router.push("/how-it-works");
    },
    calculateTotal() {
      var total =
        this.credit.moneyBase +
        this.calculateAdminNumber() +
        this.calculateSecureNumber() +
        this.calculateInterestsNumber() +
        this.calculateTechnologyNumber() +
        this.calculateIVANumber() +
        this.calculateBenefitsNumber();
      return Constants.currencyValue(total);
    },
    calculateAdmin() {
      return Constants.currencyValue(this.calculateAdminNumber());
    },
    calculateAdminNumber() {
      var admin = 0;
      var capital = this.credit.moneyBase;
      if (capital < 200000) {
        admin = 17000;
      } else if (capital < 300000) {
        admin = 25000;
      } else if (capital < 400000) {
        admin = 30000;
      } else if (capital <= 600000) {
        admin = 40000;
      } else {
        let counter200 = 800000;
        let multiplier200 = 1;
        let adminRate = 7750;
        while (capital > counter200) {
          multiplier200++;
          counter200 += 200000;
        }
        admin = 40000 + adminRate * multiplier200;
      }
      return admin;
    },
    calculateSecure() {
      return Constants.currencyValue(this.calculateSecureNumber());
    },
    calculateSecureNumber() {
      var secure =
        ((this.credit.moneyBase * this.securityByMillion) / 1000000) *
        this.calculateDays();
      return secure;
    },
    calculateInterests() {
      return Constants.currencyValue(this.calculateInterestsNumber());
    },
    calculateInterestsNumber() {
      var interests =
        this.credit.moneyBase * this.interestsPercentage * this.calculateDays();
      return interests;
    },
    calculateTechnology() {
      return Constants.currencyValue(this.calculateTechnologyNumber());
    },
    calculateTechnologyNumber() {
      return this.technologyPerDay * this.calculateDays();
    },
    calculateIVA() {
      return Constants.currencyValue(this.calculateIVANumber());
    },
    calculateIVANumber() {
      var iva =
        (this.calculateAdminNumber() +
          this.calculateSecureNumber() +
          this.calculateTechnologyNumber() +
          this.calculateBenefitsNumber()) *
        this.iva;
      return iva;
    },
    calculateDays() {
      return Constants.daysOfDifference(new Date(), this.selectedDate);
    },
    getClass: ({ id }) => ({
      "table-info": id === 0
    }),
    formatCapital() {
      return Constants.currencyValue(this.credit.moneyBase);
    }
  }
};
</script>
